// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bat[data-v-99e500f4] input[type='text'] {\n  border: solid 1px black;\n}\n.bat[data-v-99e500f4] input.coregistration__complex-step-radio-input,\n.bat[data-v-99e500f4] input.coregistration__complex-step-checkbox-input {\n  min-width: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
